import { IExpression } from "@@expressions";
import { IContainerComponent } from "./IContainerComponent";

export type TimelineModel = IContainerComponent & {
    Items: IExpression;
    ItemKeyField: string;
    ItemVariableName?: string;
    Position?: TimelinePosition;
    GetIconName?: IExpression;
    IconName?: string;
};

export enum TimelinePosition {
    Alternate = "Alternate",
    Left = "Left",
    Right = "Right",
}
